import { type Dispatch, type FC, type SetStateAction } from "react";
import { MenuItem, Stack, Typography } from "@mui/material";
import { FormattedMessage } from "react-intl";
import HighlightOffOutlinedIcon from "@mui/icons-material/HighlightOffOutlined";

interface RemoveClosingMenuItemProps {
	readonly setIsOpen: Dispatch<SetStateAction<boolean>>;
}

export const RemoveClosingMenuItem: FC<RemoveClosingMenuItemProps> = ({ setIsOpen }) => {
	return (
		<MenuItem onClick={() => setIsOpen(true)}>
			<Stack gap={1} direction="row" alignItems="center">
				<HighlightOffOutlinedIcon fontSize="small" />
				<Typography variant="body2">
					<FormattedMessage id="Remove closing" defaultMessage="Remove closing" />
				</Typography>
			</Stack>
		</MenuItem>
	);
};
